export default "__VITE_ASSET__2c06320d__"